import request from '@/util/request';
import qs from 'qs';

export const getProjectList = (params, options) =>
  request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

export const getList = (params, options) =>
  request.get('/api/v4ward/general/task/rectificationPage', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/general/task/detailRectification', Object.assign({}, options, { params }))

export const update = (params, options) =>
  request.post('/api/v4ward/general/task/submitRectification', params, options, { ContentType: 'application/json' })

export const remove = (params, options) =>
  request.post('/api/v4ward/general/task/removeRectification', qs.stringify(params), options);


